












import { Component, Vue } from 'vue-property-decorator';
import Layer from '@/components/service/InsLayer.vue';
import { FrontE } from '@/sdk/common/SysConst';
@Component({
  components: {
    Layer
  }
})
export default class App extends Vue {
  get isMobile () {
    return this.$store.state.isMobile;
  }

  get lang () {
    return this.$i18n.locale;
  }
  
  mounted() {
    Vue.prototype.$ShowLayer();
    setTimeout(() => {
      Vue.prototype.$HiddenLayer();
    }, 1500);
  }
  beforeUpdate() {
    if (this.$route.name !== 'home') {
      return;
    }
    if (this.$route.query.returnUrl) {
      let url = this.$route.query.returnUrl + '?';
      Object.keys(this.$route.query).forEach(e => {
        if (e !== 'returnUrl') url += e + '=' + this.$route.query[e] + '&';
      });
      this.$router.push(url);
    } else {
      this.$nextTick(() => {
        this.$Api.promotion.GetHomeSeoData().then(result => {
          // document.title = result.Data.Title;

          if (result.Data.Title) {
            document.title = result.Data.Title;
            (document.querySelector('meta[property="og:title"]') as any).content = result.Data.Title;
            (document.querySelector('meta[name="twitter:title"]') as any).content = result.Data.Title;
          }
          (document.querySelector('meta[name="description"]') as any).content = result.Data.Description;
          (document.querySelector('meta[property="og:description"]') as any).content = result.Data.Description;
          (document.querySelector('meta[name="twitter:description"]') as any).content = result.Data.Description;
          (document.querySelector('meta[name="keywords"]') as any).content = result.Data.Keyword;
        });
      });
    }
  }
  beforeCreate() {
    if ((FrontE.Building) && this.$route.name !== 'building') {
        this.$router.push('/building');
      }
    if (!window['MemberApi']) window['MemberApi'] = this.$Api.member;
  }
}
